
/////////////////////////////////
// racing yacht insurance

function initRacingYachtInsuranceForm() {

	if ($("#racingYachtInsuranceForm").length > 0) {

		$form = $("#racingYachtInsuranceForm");

		//init progress view
		$form.find(".progressViewElement").removeClass("disabled");
		$form.find(".progressViewElement").removeClass("active");
		$form.find(".progressViewElement").eq(0).addClass("active");
		//$form.find(".progressViewElement").eq(1).addClass("active");
		$form.find(".progressViewElement").eq(2).addClass("disabled");
		$form.find(".progressViewElement").eq(3).addClass("disabled");

		//progress buttons disabled because of disabled validation on step back
		/*
		$form.find(".progressViewElement").click(function(e){
		  e.preventDefault();
		  if(!$(this).hasClass("disabled") && !$(this).hasClass("active")){
			racingYachtInsuranceFormStep($(this));        
		  }
		});
		*/

		//init form blocks
		$form.find(".ryif-progressBlock").hide();
		$formBlock1 = $form.find("#ryif-progressBlock1").show().addClass("active");
		$formBlock2 = $form.find("#ryif-progressBlock2");
		$formBlock3 = $form.find("#ryif-progressBlock3");
		$formBlock4 = $form.find("#ryif-progressBlock4");


		$(".form-field").each(function () {
			//handle visibility switches
			var $switches = $(this).find(".formFieldVisibilitySwitch");
			if ($switches.length > 0) {
				//select first switch
				handleFormFieldVisibilitySwitchClick($switches, $switches.first());
				//handle click
				$switches.click(function () {
					handleFormFieldVisibilitySwitchClick($switches, $(this));
				});
				$switches.on("keydown", handleKeyDownForClick);
			}

			//handle visibility checkbox
			$boxes = $(this).find(".formFieldVisibilityCheckbox");
			if ($boxes.length > 0) {
				//hide fields
				$boxes.each(function () {
					$("#" + $(this).attr("data-field-id")).hide();
				})

				//handle click
				$boxes.click(function () {
					$("#" + $(this).attr("data-field-id")).toggle();
				});
				$boxes.on("keydown", handleKeyDownForClick);
			}
		});

		//handle summary change buttons
		$form.find(".summaryChangeButton").click(function (e) {
			e.preventDefault();
			var id = parseInt($(this).attr("data-id")) - 1;
			racingYachtInsuranceFormStep($form.find(".progressViewElement").eq(id), false);
		});
		$form.find(".summaryChangeButton").on("keydown", handleKeyDownForClick);

		$form.find(".hullInsuranceValue").on("change keyup", function () {
			updateRacingYachtInsuranceHullValue();
		});

		initRacingYachtInsuranceAddRows();
		initRacingYachtInsurancePageButtons();

		initRacingYachtInsuranceUpload($form.find(".skipperRows"));

		//submit button
		$("#ryif_submitButton").click(function () {
			if (document.getElementById("checkboxConditions").checked) {
				
				//remove empty hidden form fields before submit
				if ($("#radioBoatClaimsNo").prop("checked")) {
					$("#inputBoatClaimType").remove();
					$("#inputBoatClaimAmount").remove();
					$("#inputBoatClaimYear").remove();
				}
				if (!$("#radioRegattaUse").prop("checked")) {
					$("#inputBoatRegattaName").remove();
					$("#inputBoatRegattaYear").remove();
					$("#inputBoatRegattaCrewed").remove();
					$("#inputBoatRegattaDuration").remove();
				}
				
				$("#racingYachtInsuranceForm").submit();
			}
			else {
				$("#checkboxConditionsField").addClass("error");
				$("#checkboxConditionsField").siblings(".form-field__errormessage--1").show();
			}
		});
		$("#ryif_submitButton").on("keydown", handleKeyDownForClick);

		// mio radio buttons
		$form.find("#radioLimit1mio").on("change", resetRadioLimitMioErrors);
		$form.find("#radioLimit3mio").on("change", resetRadioLimitMioErrors);
		$form.find("#radioLimit5mio").on("change", resetRadioLimitMioErrors);

	}
}

function initRacingYachtInsurancePageButtons() {
	//handle button next/prev
	$form.find(".buttonPrev").unbind().click(function () {
		//console.log("prev");
		racingYachtInsuranceFormStep($form.find(".progressViewElement.active").prev(), false);
	});
	$form.find(".buttonNext").unbind().click(function () {
		//console.log("next");
		racingYachtInsuranceFormStep($form.find(".progressViewElement.active").next(), true);
	});

	$form.find(".buttonPrev").on("keydown", handleKeyDownForClick);
	$form.find(".buttonNext").on("keydown", handleKeyDownForClick);
}

function initRacingYachtInsuranceAddRows() {

	//init skipper rows
	if ($(".skipperRowsAddButton").length > 0) {
		$(".skipperRowsAddButton").unbind().click(function () {
			if ($(".skipperRows").length < 3) {
				var newId = "" + ($(".skipperRows").length + 1);
				
				var $firstRow = $(".skipperRows").first();
				var $clone = createRacingYachtInsuranceRowClone($firstRow, newId);
				$clone.appendTo(".skipperRowsContainer");
				
				var $firstSummaryRow = $(".formSummarySkipperBlockContainer").children(".formSummarySkipperBlock").first();
				var $summaryClone = createRacingYachtInsuranceSummaryRowClone($firstSummaryRow, newId);
				$summaryClone.appendTo(".formSummarySkipperBlockContainer");
				
				initRacingYachtInsuranceUpload($clone);
			}
			
			updateSkipperRowsButtons();
			
			$clone.find(".skipperUploadButton").removeAttr("onclick");
			$clone.find(".skipperUploadButton").removeAttr("disabled");
			$clone.find(".skipperUploadButton").click(function () {
				$(this).siblings(".inputSkipperFile")[0].click();
			});
		});
		$(".skipperRowsRemoveButton").unbind().click(function () {
			$(".skipperRows").last().remove();
			$(".formSummarySkipperBlock").last().remove();
			updateSkipperRowsButtons();
		});

		$(".skipperRowsRemoveButton").on("keydown", handleKeyDownForClick);
		$(".skipperRowsAddButton").on("keydown", handleKeyDownForClick);

		updateSkipperRowsButtons();
	}


	//init claim rows
	if ($(".claimRowsAddButton").length > 0) {
		$(".claimRowsAddButton").unbind().click(function () {
			
			if ($(".claimRows").length < 3) {
				var $firstRow = $(".claimRows").first();
				
				var newId = "" + ($(".claimRows").length + 1);
				var $clone = createRacingYachtInsuranceRowClone($firstRow, newId);
				$clone.appendTo(".claimRowsContainer");
				
				var $firstSummaryRow = $(".formSummaryClaimBlockContainer").children(".formSummaryClaimBlock").first();
				var $summaryClone = createRacingYachtInsuranceSummaryRowClone($firstSummaryRow, newId);
				$summaryClone.appendTo(".formSummaryClaimBlockContainer");
			}
			
			updateClaimRowsButtons();
			
		});
		$(".claimRowsAddButton").on("keydown", handleKeyDownForClick);

		$(".claimRowsRemoveButton").unbind().click(function () {
			$(".claimRows").last().remove();
			$(".formSummaryClaimBlock").last().remove();
			updateClaimRowsButtons();
		});
		$(".claimRowsRemoveButton").on("keydown", handleKeyDownForClick);

		updateClaimRowsButtons();
	}

	//init regatta rows
	if ($(".regattaRowsAddButton").length > 0) {
		$(".regattaRowsAddButton").unbind().click(function () {
			if ($(".regattaRows").length < 3) {
				var $firstRow = $(".regattaRows").first();

				var newId = "" + ($(".regattaRows").length + 1);
				var $clone = createRacingYachtInsuranceRowClone($firstRow, newId);
				$clone.appendTo(".regattaRowsContainer");

				var $firstSummaryRow = $(".formSummaryRegattaBlockContainer").children(".formSummaryRegattaBlock").first();
				var $summaryClone = createRacingYachtInsuranceSummaryRowClone($firstSummaryRow, newId);
				$summaryClone.appendTo(".formSummaryRegattaBlockContainer");
			}
			updateRegattaRowsButtons();
		});
		$(".regattaRowsRemoveButton").unbind().click(function () {
			$(".regattaRows").last().remove();
			$(".formSummaryRegattaBlock").last().remove();
			updateRegattaRowsButtons();
		});
		$(".regattaRowsAddButton").on("keydown", handleKeyDownForClick);
		$(".regattaRowsRemoveButton").on("keydown", handleKeyDownForClick);

		updateRegattaRowsButtons();

	}
}
function updateSkipperRowsButtons() {
	if ($(".skipperRows").length > 1) {
		$(".skipperRowsRemoveButton").show();
	}
	else {
		$(".skipperRowsRemoveButton").hide();
	}

	if ($(".skipperRows").length >= 3) {
		$(".skipperRowsAddButton").hide();
	}
	else {
		$(".skipperRowsAddButton").show();
	}
}
function updateClaimRowsButtons() {
	$(".claimRowsRemoveButton").hide();
	if ($(".claimRows").length > 1) {
		$(".claimRowsRemoveButton").show();
	}
	else {
		$(".claimRowsRemoveButton").hide();
	}

	if ($(".claimRows").length >= 3) {
		$(".claimRowsAddButton").hide();
	}
	else {
		$(".claimRowsAddButton").show();
	}
}
function updateRegattaRowsButtons() {
	if ($(".regattaRows").length > 1) {
		$(".regattaRowsRemoveButton").show();
	}
	else {
		$(".regattaRowsRemoveButton").hide();
	}

	if ($(".regattaRows").length >= 3) {
		$(".regattaRowsAddButton").hide();
	}
	else {
		$(".regattaRowsAddButton").show();
	}
}

function createRacingYachtInsuranceRowClone($firstRow, newId) {

	var $clone = $firstRow.clone();
	var newNameId = newId - 1;

	$clone.find("input").removeAttr("required").val("");
	$clone.find("textarea").removeAttr("required").val("");
	$clone.find("input").removeClass("requiredData");
	$clone.find("textarea").removeClass("requiredData");
	$clone.find("input").removeClass("selected");
	$clone.find("textarea").removeClass("selected");
	$clone.find("select").removeClass("selected");
	$clone.find(".select-style").removeClass("selected");
	$clone.find("select").prop("value", "");
	$clone.find("label span").hide();
	$clone.find(".form-field__errormessage--1").hide();
	$clone.find(".error").removeClass("error");
	$clone.find(".formRowLabel span").hide();

	$clone.find(".form-field").each(function () {

		$(this).find("label").attr("for", $(this).find("label").attr("for") + newId);

		$(this).find("input").each(function () {
			$(this).attr("id", $(this).attr("id") + newId);
			if ($(this).attr("name")) {
				$(this).attr("name", $(this).attr("name").replace("[0]", "[" + newNameId + "]"));
			}
			if ($(this).attr("data-summary-id")) {
				$(this).attr("data-summary-id", $(this).attr("data-summary-id") + newId);
			}
		});

		$(this).find("select").attr("id", $(this).find("select").attr("id") + newId);
		if ($(this).find("select").attr("name")) {
			$(this).find("select").attr("name", $(this).find("select").attr("name").replace("[0]", "[" + newNameId + "]"));
		}
		if ($(this).find("select").attr("data-summary-id")) {
			$(this).find("select").attr("data-summary-id", $(this).find("select").attr("data-summary-id") + newId);
		}
		if ($(this).find(".nice-select").length > 0) {
			$(this).find(".nice-select .current").html($(this).find(".nice-select li").first().html());
			$(this).find(".nice-select li").removeClass("selected");
			$(this).find(".nice-select li").first().addClass("selected");
		}

		$(this).find("textarea").attr("id", $(this).find("textarea").attr("id") + newId);
		if ($(this).find("textarea").attr("name")) {
			$(this).find("textarea").attr("name", $(this).find("textarea").attr("name").replace("[0]", "[" + newNameId + "]"));
		}
		if ($(this).find("textarea").attr("data-summary-id")) {
			$(this).find("textarea").attr("data-summary-id", $(this).find("textarea").attr("data-summary-id") + newId);
		}

		if ($(this).find(".fileUploadResult").length > 0) {
			$(this).find(".fileUploadResult").html("");
		}
		if ($(this).find(".uploadFileElement").length > 0) {
			var $uploadElement = $(this).find(".uploadFileElement");
			$uploadElement.html($uploadElement.data('infotext'));
			$uploadElement.show();
		}

	});

	$clone.find("select").change(updateForms);
	$clone.find("input").change(updateForms);

	return $clone;
}

function createRacingYachtInsuranceSummaryRowClone($firstSummaryRow, newId) {

	var $summaryClone = $firstSummaryRow.clone();
	$summaryClone.find(".formSummaryText").each(function () {
		$(this).attr("id", $(this).attr("id") + newId);
	});

	$summaryClone.find('label .uploadFileElement').html($(this).data('infotext'));

	return $summaryClone;

}


function handleFormFieldVisibilitySwitchClick($switches, $switch) {

	//hide all fields
	$switches.each(function () {
		$("#" + $(this).attr("data-field-id")).hide();
	});

	//show selected fields
	$("#" + $switch.attr("data-field-id")).show();
}

function racingYachtInsuranceFormStep($progressViewElement, validate) {

	var validationResult = true;
	if (validate) {
		//validate form
		validationResult = validateRacingYachtInsuranceForm();
	}
	else {
		//disable validation => set result to true
		validationResult = true;
	}

	if (validationResult) {
		//console.log("validated!");
		var blockId = $progressViewElement.attr("data-block-id");
		$("#racingYachtInsuranceForm").find(".progressViewElement").removeClass("active");
		$progressViewElement.prevAll(".progressViewElement").removeClass("done");
		$progressViewElement.prevAll(".progressViewElement").addClass("done");
		$progressViewElement.addClass("active");
		$progressViewElement.next().removeClass("disabled");
		$("#racingYachtInsuranceForm").find(".ryif-progressBlock").hide().removeClass("active");
		$("#racingYachtInsuranceForm").find("#" + blockId).show().addClass("active");

		$('html, body').animate({
			scrollTop: $progressViewElement.offset().top - 60
		}, 100);

		initRacingYachtInsurancePageButtons();
		initRacingYachtInsuranceAddRows();

		updateRacingYachtInsuranceSummary();

		updateRacingYachtInsuranceHullValue();
	}
	else {
		//console.log("not validated!");
		scrollToError();
		// validation error!
	}
}

function validateRacingYachtInsuranceForm() {

	var $currentBlock = $("#racingYachtInsuranceForm").find(".ryif-progressBlock.active");

	//testing!
	// return true;
	//testing!

	var error = false;

	$currentBlock.find("input").each(function () {
		if (getRacingYachtInsuranceFormFieldError($(this))) {
			error = true;
		}
	});
	$currentBlock.find("textarea").each(function () {
		if (getRacingYachtInsuranceFormFieldError($(this))) {
			error = true;
		}
	});
	$currentBlock.find("select").each(function () {
		if (getRacingYachtInsuranceFormFieldError($(this))) {
			error = true;
		}
	});

	$currentBlock.find(".fileUpload").each(function () {
		if ($(this).hasClass("error")) {
			error = true;
		}
	});

	//type of cover
	var hull1CheckError = $("#checkboxHullInsurance").is(":visible") && !document.getElementById("checkboxHullInsurance").checked;
	var hull2CheckError = $("#checkboxLiabiltyInsurance").is(":visible") && !document.getElementById("checkboxLiabiltyInsurance").checked;
	if (hull1CheckError && hull2CheckError) {
		error = true;
		$("#formFieldTypeOfCover").addClass("error");
		$("#formFieldTypeOfCover .errormessage").show();
	}
	else {
		$("#formFieldTypeOfCover").removeClass("error");
		$("#formFieldTypeOfCover .errormessage").hide();

	}

	//limit per year
	$("#radioLimit1mioFormfield").removeClass("error");
	$("#radioLimit3mioFormfield").removeClass("error");
	$("#radioLimit5mioFormfield").removeClass("error");
	$("#radioLimitFormfield").removeClass("error");
	$("#radioLimitFormfield").find(".form-field__errormessage--1").hide();
	if (document.getElementById("checkboxLiabiltyInsurance").checked) {
		console.log("a:" + $("#radioLimit1mio").prop('checked'));
		console.log("a:" + $("#radioLimit3mio").prop('checked'));
		console.log("a:" + $("#radioLimit5mio").prop('checked'));
		if (!$("#radioLimit1mio").prop('checked') && !$("#radioLimit3mio").prop('checked') && !$("#radioLimit5mio").prop('checked')) {
			error = true;
			$("#radioLimit1mioFormfield").addClass("error");
			$("#radioLimit3mioFormfield").addClass("error");
			$("#radioLimit5mioFormfield").addClass("error");
			$("#radioLimitFormfield").addClass("error");
			$("#radioLimitFormfield").find(".form-field__errormessage--1").show();
		}
	}


	if (error) {
		return false;
	}

	return true;
}

function getRacingYachtInsuranceFormFieldError($ff) {


	var required = $ff.hasClass("requiredData");
	var visible = $ff.is(":visible");

	if ($ff.parent(".select-style").length > 0) {
		visible = $ff.parent(".select-style").is(":visible");
	}
	if ($ff.parent(".fileUpload").length > 0) {
		visible = $ff.parent(".fileUpload").is(":visible");
	}

	//console.log("validate... " + $ff.attr("id") + " (visible:" + visible + " / required:" + required + ")");

	var error = false;

	if (visible && required) {

		$ff.closest(".form-field").removeClass("error");
		$ff.siblings(".form-field__errormessage--1").hide();
		$ff.siblings(".form-field__errormessage--2").hide();

		//use hidden field on file upload fields
		if ($ff.siblings(".uploadCVFileElement").length > 0) {
			$ff = $ff.siblings(".uploadCVFileElement");
		}

		//check value
		if (!$ff.val() || $ff.val() == "") {
			$ff.closest(".form-field").addClass("error");
			$ff.siblings(".form-field__errormessage--1").show();
			error = true;
		}

		//check mail
		if ($ff.attr("id") == "inputEmail" && $ff.val() != "") {
			if (!validateEmail($ff.val())) {
				$ff.closest(".form-field").addClass("error");
				$ff.siblings(".form-field__errormessage--2").show();
				error = true;
			}
		}

		//console.log("validate ok! " + $ff.attr("id"));
	}
	return error;
}


function resetRadioLimitMioErrors() {
	$("#radioLimit1mioFormfield").removeClass("error");
	$("#radioLimit3mioFormfield").removeClass("error");
	$("#radioLimit5mioFormfield").removeClass("error");
	$("#radioLimitFormfield").removeClass("error");
	$("#radioLimitFormfield").find(".form-field__errormessage--1").hide();
}


function updateRacingYachtInsuranceHullValue() {
	var $form = $("#racingYachtInsuranceForm");
	var sum = 0;
	$form.find(".hullInsuranceValue").each(function () {
		if ($(this).val() != "") {
			sum += parseInt($(this).val());
		}
	});

	if (sum > 0) {
		sum = sum.toLocaleString('de-DE');
		$form.find(".hullInsuranceValueSum").html(sum + " €");
		$form.find("#ryif-summary-valueTotal").html(sum + " €");

		$form.find(".hullInsuranceValueSumInput").val(sum);
	}
	else {
		$form.find(".hullInsuranceValueSum").html("");
		$form.find("#ryif-summary-valueTotal").html("");

		$form.find(".hullInsuranceValueSumInput").val(0);
	}
}
function updateRacingYachtInsuranceSummary() {

	var $form = $("#racingYachtInsuranceForm");

	//add value to summary
	$form.find(".summaryData").each(function () {
		var id = $(this).attr("data-summary-id");
		var field = $form.find("#" + id);
		var value = "";

		if ($(this).is("input")) {
			value = $(this).val();

			if ($(this).hasClass("hullInsuranceValue")) {
				value = $(this).val() + " €";
			}
		}
		else if ($(this).is("select")) {
			value = $(this).val();
		}
		else if ($(this).is("textarea")) {
			value = $(this).val();
		}

		if (value == "") {
			value = "-"
		}

		field.html(value);
	});

	//private or company?
	if ($("#radioPrivatePerson").prop("checked")) {
		$("#formSummaryBodyBlockPrivate").show();
		$("#formSummaryBodyBlockCompany").hide();
	}
	else if ($("#radioCompany").prop("checked")) {
		$("#formSummaryBodyBlockPrivate").hide();
		$("#formSummaryBodyBlockCompany").show();
	}

	//claims
	if ($("#radioBoatClaimsNo").prop("checked")) {
		$("#ryif-summary-boatClaims").html("no");
		$(".formSummaryClaimBlockContainer").hide();
	}
	else if ($("#radioBoatClaimsYes").prop("checked")) {
		$("#ryif-summary-boatClaims").html("yes");
		$(".formSummaryClaimBlockContainer").show();
	}

	//vessel use
	if ($("#radioRegattaUse").prop("checked")) {
		$("#ryif-summary-vesselUse").html($("#radioRegattaUse").attr("value"));
		$(".formSummaryRegattaBlockContainer").show();
	}
	else if ($("#radioPrivateUse").prop("checked")) {
		$("#ryif-summary-vesselUse").html($("#radioPrivateUse").attr("value"));
		$(".formSummaryRegattaBlockContainer").hide();
	}

	//foiling vessel?
	if ($("#radioBoatFoilingYes").prop("checked")) {
		$("#ryif-summary-boatFoiling").html("yes");
		$(".formSummaryFoilingInfo").show();
	}
	else if ($("#radioBoatFoilingNo").prop("checked")) {
		$("#ryif-summary-boatFoiling").html("no");
		$(".formSummaryFoilingInfo").hide();
	}

	if ($("#radioBoatFoilingBuilt").prop("checked")) {
		$("#ryif-summary-boatFoilingBuilt").html("yes");
	}
	else {
		$("#ryif-summary-boatFoilingBuilt").html("no");
	}

	if ($("#radioBoatFoilingModified").prop("checked")) {
		$("#ryif-summary-boatFoilingModified").html("yes");
	}
	else {
		$("#ryif-summary-boatFoilingModified").html("no");
	}


	//cruising areas
	var listCruisingAreas = "";
	$form.find(".checkboxCruisingAreas").each(function () {
		if ($(this).prop("checked")) {
			listCruisingAreas += $(this).attr("data-value") + ", ";
		}
	});

	if (listCruisingAreas.length > 0) {
		listCruisingAreas = listCruisingAreas.substr(0, listCruisingAreas.length - 2);
	}

	$("#ryif-summary-cruisingAreas").html(listCruisingAreas);

	//type of cover
	$(".formSummaryTypeHullBlock").hide();
	$(".formSummaryTypePartyBlock").hide();
	var toc = "";
	if (document.getElementById("checkboxHullInsurance").checked) {
		$(".formSummaryTypeHullBlock").show();
		toc += "Hull Insurance";
	}
	if (document.getElementById("checkboxLiabiltyInsurance").checked) {
		$(".formSummaryTypePartyBlock").show();
		if (toc != "") {
			toc += ", ";
		}
		toc += "Third Party Liability Insurance";

		if (document.getElementById("radioLimit1mio").checked) {
			$("#ryif-summary-limit").html($("#radioLimit1mio").attr("value"));
		}
		else if (document.getElementById("radioLimit3mio").checked) {
			$("#ryif-summary-limit").html($("#radioLimit3mio").attr("value"));
		}
		else if (document.getElementById("radioLimit5mio").checked) {
			$("#ryif-summary-limit").html($("#radioLimit5mio").attr("value"));
		}
	}
	$("#ryif-summary-typeOfCover").html(toc);
	$("#ryif-summary-limit").html()

}


/**
 * Contains file upload and delete ajax logic.
 * */
 function initRacingYachtInsuranceUpload($row) {

	var $formfield = $row.find(".fileUpload");

	$formfield.find("input[type='file']").each(function (idx, el) {
		$(el).on('change', function () {
			var $replaceText = $(this).next('label').find('.uploadFileElement');
			var $replaceHiddenField = $(this).siblings('.uploadCVFileElement');
			if ($(this)[0].files.length) {
				$($replaceText).html($(this)[0].files[0].name);
				$($replaceHiddenField).val($(this)[0].files[0].name);
			}
			else {
				$($replaceText).html(ftc_tr.chooseFileText);
			}
			$($replaceText).show();
		});
	});

	//$("#fileuploadProgress").hide();
	$row.find('.fileUploadResult').hide();

	$formfield.each(function () {
		var $inputElement = $(this);
		var $inputField = $(this).find('input[type=file]');
		var inputFieldId = $($inputField)[0].id;
		var $uploadButton = $(this).find('button');
		var $uploadLabel = $(this).find('label .uploadFileElement');
		var $deleteButton = $(this).find('.inputfileDelete');
		var $result = $(this).find('.fileUploadResult');

		/*
		console.log("initRacingYachtInsuranceUpload() $inputField:" + $inputField);
		console.log("initRacingYachtInsuranceUpload() inputFieldId:" + inputFieldId);
		console.log("initRacingYachtInsuranceUpload() $uploadButton:" + $uploadButton);
		console.log("initRacingYachtInsuranceUpload() $uploadLabel:" + $uploadLabel);
		console.log("initRacingYachtInsuranceUpload() $deleteButton:" + $deleteButton);
		console.log("initRacingYachtInsuranceUpload() $result:" + $result);
		console.log("initRacingYachtInsuranceUpload() upload url:" + $('#' + inputFieldId).attr("data-url"));
		*/

		$deleteButton.hide();

		$($inputField).fileupload({
			url: $('#' + inputFieldId).attr("data-url"),
			dataType: "json",
			//acceptFileTypes: /(\.|\/)(gif|jpe?g|png|te?xt)$/i,
			maxFileSize: $('#' + inputFieldId).attr("data-maxfilesize"),
			messages: {
				maxFileSize: $('#' + inputFieldId).attr("data-errormessage")
			},
			progressall: function (e, data) {

				$(".ibsLoadmask").show();

			},
			done: function (e, data) {

				$(".ibsLoadmask").hide();

				//console.log("initRacingYachtInsuranceUpload() DONE!");

				if (data.result.files && data.result.files.length > 0) {
					$.each(data.result.files, function (index, file) {

						if (file.url) {

							$($result).html("").removeClass('errormessage');
							$($uploadButton).removeClass("disabled");
							$($uploadButton).addClass("disabled");
							$($uploadButton).prop('disabled', true);


							$('#' + inputFieldId).prop('required', false);

							if ($('#' + inputFieldId).data("delete-url") != "") {
								$($deleteButton).show();

								var deleteFunction = function (event) {
									event.preventDefault();
									$(".ibsLoadmask").show();
									$.ajax({
										type: "POST",
										url: $('#' + inputFieldId).data("delete-url"),
										data: {
											file: file.name
										},
										complete: function () {
											$($uploadLabel).html($($uploadLabel).data('infotext'));
											$('#' + inputFieldId).prop('required', true);
											$(".ibsLoadmask").hide();
										}
									})
										.always(function (data) {
											$($uploadButton).removeClass("disabled");
											$($uploadButton).prop('disabled', false);
											$($deleteButton).hide();
											$(".ibsLoadmask").hide();
										});

									//remove handler after firing
									$($deleteButton).unbind('click', deleteFunction);
								};

								$($deleteButton).on("keydown", handleKeyDownForClick);
								$($deleteButton).click(deleteFunction);
							}
						}
						else if (file.error) {
							$($result).html(file.error);
							$($result).show();
							$($result).addClass("error");

							//console.log("initRacingYachtInsuranceUpload() ERROR!");

							if ($('#' + inputFieldId).data("delete-url") != "") {
								$.ajax({
									type: "POST",
									url: $('#' + inputFieldId).data("delete-url"),
									data: {}
								}).always(function (data) {
									$($uploadButton).removeClass("disabled");
									$($uploadButton).prop('disabled', false);
									$($inputElement).find(".uploadCVFileElement").val("");
									$($inputField).val("");
								});
								$('#' + inputFieldId).prop('required', true);
							}
						}
					});
				}
				else {
					//console.log("initRacingYachtInsuranceUpload() FAIL!");
					$($result).html("An error occurred in the upload. Please try again later.");
					$($result).show();
					$($result).addClass("error");
				}

			},
			destroy: function () {
				$(".ibsLoadmask").hide();
			}
		}).on('fileuploadfail', function (e, data) {
			$(".ibsLoadmask").hide();

			//console.log("initRacingYachtInsuranceUpload() FAIL!");

			if (data.result && data.result.files) {
				$.each(data.result.files, function (index, file) {
					if (file.error) {
						$uploadLabel.html('select file');
						$($result).html(file.error);
						$($result).show();
						$($result).addClass("error");
					}
				});
			}
			else {
				$uploadLabel.html('select file');
				$($result).html("An error occurred in the upload. Please try again later.");
				$($result).show();
				$($result).addClass("error");
			}

		}).on('fileuploadprocessalways', function (e, data) {

			//console.log("initRacingYachtInsuranceUpload() ALWAYS!");

			var currentFile = data.files[data.index];
			if (data.files.error && currentFile.error) {
				// there was an error, do something about it
				$uploadLabel.html('select file');
				$($result).html(currentFile.error);
				$($result).show();
				$($result).addClass("error");
				consolog(currentFile.error);
			}

			$(".ibsLoadmask").hide();
		});

	});
}